import CreationBody from 'components/CreateQuiz/CreationBody';

const Mobile = () => <CreationBody device={'mobile'} />;

export default Mobile;
